const Template = `<div>
<div class="notifications">
<div class="notification-table">
<b-table
      :items="new_notifications"
      :fields="fields"
      :filters="filterNotifications"
      striped
      borderless
      small
      hover
      dark>

        <template v-slot:cell(icons)="data">
          {{ tubeIcons(data.item) }}
        </template>

        <template v-slot:cell(message)="data">
          {{ getMessage(data.item) }}
        </template>

    </b-table>
    </div>

    <div class="filtration">
    <b-form-group :label="$t('messages.filterBy')">
      <b-form-radio-group
      v-model="selectedValue"
      :options="filters"
      class="checkbox-style"
      stacked>

      </b-form-radio-group>
      <b-button
      v-on:click="resetFilters">{{$t('messages.resetButton')}}</b-button>
      </b-form-group>
    </div>
    </div>
    </div>`
export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page5_notifications/notifications/template.js